import {EventBus} from "../../../common/ts/events/EventBus";
import tracking from "../../../common/ts/core/tracking";
import {SECTION_CLICKED_EVENT_TYPE} from "../../../common/ts/tracking/constants";
import {MitulaSerpPageData} from "./SerpPage";

function init(pageData: MitulaSerpPageData) {
    registerHorizontalNavigationChipsClick(pageData);
    registerRemoveKeywordPartsChipsClick(pageData);
}

function registerHorizontalNavigationChipsClick(pageData: MitulaSerpPageData) {
    document.querySelectorAll("#property-type-chips > a").forEach((element) => {
        (element as HTMLElement).addEventListener('click', () => createHandleClick(pageData)(element as HTMLElement));
    });

    document.querySelectorAll("#nearby-location-suggestions > a").forEach((element) => {
        (element as HTMLElement).addEventListener('click', () => createHandleClick(pageData)(element as HTMLElement));
    });

    document.querySelectorAll("#horizontalNavigationInterlinkingBlockContainer a").forEach((element) => {
        (element as HTMLElement).addEventListener('click', () => createHandleClick(pageData)(element as HTMLElement));
    });

    document.querySelectorAll("#verticalNavigationInterlinkingBlockContainer a").forEach((element) => {
        (element as HTMLElement).addEventListener('click', () => createHandleClick(pageData)(element as HTMLElement));
    });

    document.querySelectorAll("#narrowNavigationInterlinkingBlockContainer a").forEach((element) => {
        (element as HTMLElement).addEventListener('click', () => createHandleClick(pageData)(element as HTMLElement));
    });
}

function registerRemoveKeywordPartsChipsClick(pageData: MitulaSerpPageData) {
    document.querySelectorAll("#remove-keyword-parts a").forEach((element) => {
        (element as HTMLElement).addEventListener('click', () => createHandleClick(pageData)(element as HTMLElement));
    });
}

function createHandleClick(pageData: MitulaSerpPageData): (chip: HTMLElement) => void {
    return (chip: HTMLElement) => {
        const name = chip.dataset.name;
        const section = chip.dataset.section;

        if (!name || !section) return;

        EventBus.getInstance().emit(new tracking.TrackWebTrackingEvent({
            type: SECTION_CLICKED_EVENT_TYPE,
            serpUrl: window.location.href,
            sectionName: name,
            value: chip.innerText,
            section: section,
            pageViewId: pageData.pageviewId,
        }));
    }
}

export default {
    init,
};